
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-profile",
      function () {
        return require("private-next-pages/company-profile.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-profile"])
      });
    }
  